import React, { useEffect, useState } from 'react'
import Button from '@mui/material/Button';
import { useParams, useNavigate, Link } from "react-router-dom";
import FotterMain from '../BaseComponents/FotterMain';
import Header from '../BaseComponents/Header';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { getInvestorDocumentList } from '../../networkCalls';
import LoadingCellFullPage from '../LoadingCell/LoadingCellFullPage';
import { Helmet } from 'react-helmet';
import DocumentDataCell from './DocumentDataCell';
import parse from 'html-react-parser';
import SubCatBoxDisplay from './SubCatBoxDisplay';
import { format } from 'date-fns'
const Page = () => {



    const [pageslug, setpageslug] = useState(useParams());

    console.log('pageslug', pageslug?.investorURL)

    const navigate = useNavigate();
    const [value, setValue] = React.useState(null);

    const [startdate, setStartDate] = React.useState(null);
    const handleChange = (newValue) => {
        setValue(newValue);
        setStartDate(format(newValue, "MM-yyyy"));
    };
    const [value2, setValue2] = React.useState(null);


    const [endDate, setEndDate] = React.useState(null);
    const handleChange2 = (newValue) => {
        setValue2(newValue);
        // setValue2(format(newValue, "dd-MM-yyyy"));
        setEndDate(format(newValue, "MM-yyyy"));
    };
    const { investorURL } = useParams();
    const [loading, setLoading] = useState(false);
    const [pageData, setPageData] = useState(false);

    const pullDetails = () => {
        var data = new FormData();
        data.append('catSlug', investorURL);
        data.append('startDate', startdate);
        data.append('endDate', endDate);
        setLoading(true);
        getInvestorDocumentList(data).then((res) => {
            setLoading(false);
            switch (res.data.status) {
                case 1:
                    setPageData(res.data);
                    return true;
                case 0:
                    break;
                default:
                    return;
            }
        })
    }

    const clearData = () => {
        //pullDetails();
        window.location.reload(false);
    }
    const filterData = () => {
        pullDetails();
    }
    useEffect(() => {
        pullDetails();
    }, []);
    return (
        <>
            <Helmet>
                <title>{pageData?.Data?.metaTitle}</title>
                <meta name="description" content={pageData?.Data?.metaDescription} />
            </Helmet>
            <Header />
            {loading ? <><LoadingCellFullPage /></> : <>
                <div className='innerpagebg pt-5 pb-5'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12 text-left m-auto'>
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div>
                                        <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                                            <span className='txtred'>{pageData?.Data?.name} </span>
                                        </h4>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        <Button variant="text" onClick={() => navigate(-1)} size="medium" className='d-inline-block ms-2'>
                                            BACK
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12'>
                                <hr />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-6'></div>
                            {pageslug?.investorURL == 'investor-service-request' || pageslug?.investorURL == 'investors-contact' ? <>
                            </> : <>
                                {pageData && pageData?.InvestorDocumentList && pageData?.InvestorDocumentList?.length > 0 && pageData?.InvestorDocumentList?.[0]?.subCatId ? <>
                                </> : <>
                                    <div className='col-12 col-lg-6 text-end'>
                                        <div className='row'>
                                            <div className='col-6 col-lg-4 mb-3'>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <MobileDatePicker
                                                        views={['year', 'month']}
                                                        label="Date Start"
                                                        inputFormat="MM/yyyy"
                                                        value={value}
                                                        minDate={new Date('2014-01-01')}
                                                        maxDate={new Date()}
                                                        onChange={handleChange}
                                                        renderInput={(params) => <TextField className='me-2 w-100' size='small' {...params} />}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                            <div className='col-6 col-lg-4 mb-3'>
                                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                    <MobileDatePicker
                                                        views={['year', 'month']}
                                                        label="Date End"
                                                        inputFormat="MM/yyyy"
                                                        value={value2}
                                                        minDate={new Date('2014-01-01')}
                                                        maxDate={new Date()}
                                                        onChange={handleChange2}
                                                        renderInput={(params) => <TextField className='me-2 w-100' size='small' {...params} />}
                                                    />
                                                </LocalizationProvider>
                                            </div>
                                            <div className='col-12 col-lg-4 mb-3'>
                                                <Button variant="outlined" onClick={() => filterData()} size="medium" className='d-inline-block ms-2'>
                                                    FILTER
                                                </Button>
                                                <Button variant="text" onClick={() => clearData()} size="medium" className='d-inline-block ms-2'>
                                                    CLEAR
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </>
                                }
                            </>}


                            <div className='col-12 text-left'>
                                {pageData?.Data?.description != null ? <><div className='mb-3'>{parse(`${pageData?.Data?.description}`)}</div></> : <></>}
                                <hr />
                            </div>
                        </div>
                    </div>
                    <div className='container mt-3'>
                        <div className='row'>
                            {pageData && pageData?.InvestorDocumentList && pageData?.InvestorDocumentList?.length > 0 && pageData?.InvestorDocumentList?.[0]?.subCatId ? <>
                                {pageData?.InvestorDocumentList?.map((data, i) => (
                                    <SubCatBoxDisplay key={i} item={data} />
                                ))}
                            </> : <>
                                {pageData && pageData?.InvestorDocumentList && pageData?.InvestorDocumentList?.length > 0 && pageData?.InvestorDocumentList?.map((data, i) => (
                                    <DocumentDataCell key={i} item={data} />
                                ))}
                            </>
                            }
                            {/* {pageData && pageData?.InvestorDocumentList && pageData?.InvestorDocumentList?.length > 0 && pageData?.InvestorDocumentList?.map((data, i) => (
                                <div key={i} className='col-12'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <h3 className='f18'>{data?.name}</h3>
                                            <p>{data?.description}</p>
                                        </div>
                                    </div>
                                    <div className='row'>
                                    {data && data?.documents?.length > 0 && data?.documents?.map((item, i) => (
                                        <DocumentDataCell key={i} item={item} />
                                    ))}
                                    </div>
                                    <hr />
                                </div>
                            ))} */}
                        </div>
                    </div>
                </div>
            </>}
            <FotterMain />
        </>
    )
}

export default Page